import React from 'react';
import { Link } from 'react-router-dom';
import rushLogo from './rush-logo.png';
import { RushThemeToggle } from './rushTheme';

// Maps Rush design's HTML links to our React Router paths.
// Keep the file names from the design as map keys so other ported pages can reuse this.
export const HREF_MAP = {
  'Rush Studio Landing.html': '/',
  'Features.html': '/features',
  'Languages.html': '/languages',
  'Integrations.html': '/integrations',
  'Pricing.html': '/pricing',
  'Customers.html': '/customers',
  'Blog.html': '/blog',
  'About.html': '/about',
  'Careers.html': '/careers',
  'Contact.html': '/contact',
  'Security.html': '/security',
  'Privacy.html': '/privacy',
  'Terms.html': '/terms',
  'GDPR.html': '/gdpr',
  'Sign In.html': '/login',
  'Sign Up.html': '/register',
  'Role Technical Writers.html': '/roles/technical-writers',
  'Role Marketing.html': '/roles/marketing',
  'Role Localization Managers.html': '/roles/localization-managers',
  'Role Product Managers.html': '/roles/product-managers',
  'Role Design Ops.html': '/roles/design-ops',
};

export const RushNav = ({ active }) => {
  return (
    <header className="rs-nav">
      <div className="rs-container">
        <div className="rs-nav-inner">
          <Link to="/" className="rs-logo rs-logo-img" aria-label="Rush Studio home">
            {/* LCP image: served from a stable public path (matches the <link rel="preload">
                in index.html) and marked high-priority so it's fetched first. */}
            <img
              src={`${process.env.PUBLIC_URL}/rush-logo.png`}
              alt="Rush Studio"
              fetchpriority="high"
              decoding="async"
              width="212"
              height="98"
            />
          </Link>
          <nav className="rs-nav-links">
            <div className="rs-nav-drop">
              <button type="button" className={`rs-nav-trigger ${active === 'features' ? 'active' : ''}`} aria-haspopup="true">
                Features
                <svg className="caret" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M2 4l3 3 3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="rs-nav-menu is-left">
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">Overview</div>
                  <Link className="rs-nav-menu-item" to="/features">
                    <span className="nm-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="2" y="2" width="4.4" height="4.4" rx="1" stroke="currentColor" strokeWidth="1.4" /><rect x="7.6" y="2" width="4.4" height="4.4" rx="1" stroke="currentColor" strokeWidth="1.4" /><rect x="2" y="7.6" width="4.4" height="4.4" rx="1" stroke="currentColor" strokeWidth="1.4" /><rect x="7.6" y="7.6" width="4.4" height="4.4" rx="1" stroke="currentColor" strokeWidth="1.4" /></svg>
                    </span>
                    <div className="nm-body">
                      <span className="nm-title">All features</span>
                      <span className="nm-sub">The whole toolkit, on one page</span>
                    </div>
                  </Link>
                  <div className="rs-nav-menu-cta">
                    <div className="nm-cta-title">What sets us apart</div>
                    <div className="nm-cta-sub">Seven things you won't find bolted onto a legacy TMS.</div>
                    <Link className="nm-cta-link" to="/features">See all features →</Link>
                  </div>
                </div>
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">Deep dives</div>
                  <Link className="rs-nav-menu-item" to="/features/brand-voice">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 5.5v3M5.5 3.5v7M8.5 4.5v5M11.5 2.5v9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Brand voice</span><span className="nm-sub">Tone &amp; terms the AI follows</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/automations">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="1.5" y="2" width="5" height="3.6" rx="1" stroke="currentColor" strokeWidth="1.3" /><rect x="7.5" y="8.4" width="5" height="3.6" rx="1" stroke="currentColor" strokeWidth="1.3" /><path d="M6.5 3.8h2a1.5 1.5 0 011.5 1.5v3.1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Automations</span><span className="nm-sub">Localize on every PR</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/ai-quality">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 10a5 5 0 0110 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /><path d="M7 10l2.6-2.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">AI quality</span><span className="nm-sub">Scored &amp; flagged before review</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/preview">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 7s2.2-3.5 5.5-3.5S12.5 7 12.5 7 10.3 10.5 7 10.5 1.5 7 1.5 7z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /><circle cx="7" cy="7" r="1.5" stroke="currentColor" strokeWidth="1.3" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Catch broken layouts</span><span className="nm-sub">Preview in the real UI</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/layout-risk">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2l5.5 10h-11L7 2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /><path d="M7 6v3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /><circle cx="7" cy="10.6" r="0.5" fill="currentColor" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Pre-flight layout risk</span><span className="nm-sub">Spot overflow before you translate</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/resonance">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="1.4" stroke="currentColor" strokeWidth="1.4" /><path d="M3.8 3.8a4.5 4.5 0 000 6.4M10.2 3.8a4.5 4.5 0 010 6.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Resonance</span><span className="nm-sub">Predict how each market reacts</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/features/autopilot">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M8 1.5L3 8h3.2l-1 4.5L12 6H8.4l1-4.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Quality Autopilot</span><span className="nm-sub">AI quality that runs itself</span></div>
                  </Link>
                </div>
              </div>
            </div>
            <Link to="/languages" className={active === 'languages' ? 'active' : ''}>Languages</Link>
            <Link to="/integrations" className={active === 'integrations' ? 'active' : ''}>Integrations</Link>
            <Link to="/pricing" className={active === 'pricing' ? 'active' : ''}>Pricing</Link>
            <div className="rs-nav-drop">
              <button type="button" className={`rs-nav-trigger ${active === 'customers' ? 'active' : ''}`} aria-haspopup="true">
                Customers
                <svg className="caret" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M2 4l3 3 3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="rs-nav-menu">
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">Overview</div>
                  <Link className="rs-nav-menu-item" to="/customers">
                    <span className="nm-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <circle cx="7" cy="5" r="2.4" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M2 12c.7-2.4 2.6-3.4 5-3.4s4.3 1 5 3.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                    </span>
                    <div className="nm-body">
                      <span className="nm-title">Early access</span>
                      <span className="nm-sub">Be one of our first teams</span>
                    </div>
                  </Link>
                  <div className="rs-nav-menu-cta">
                    <div className="nm-cta-title">Launching in 2027</div>
                    <div className="nm-cta-sub">Join early access and help shape Rush Studio.</div>
                    <Link className="nm-cta-link" to="/customers">Get early access →</Link>
                  </div>
                </div>
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">By role</div>
                  <Link className="rs-nav-menu-item" to="/roles/technical-writers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 2h6l2 2v8H3z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M5 6h4M5 8.5h4M5 11h2.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Technical writers</span><span className="nm-sub">Docs that translate on every PR</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/marketing">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 5.5L10 3v8L2.5 8.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M4 8.5v2.5h2V9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Marketing teams</span><span className="nm-sub">Campaigns shipped in every market</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/localization-managers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.4" /><path d="M2 7h10M7 2c1.6 1.5 1.6 8.5 0 10M7 2c-1.6 1.5-1.6 8.5 0 10" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Localization managers</span><span className="nm-sub">Run the whole pipeline from one screen</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/product-managers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="2" y="3" width="10" height="8" rx="1.4" stroke="currentColor" strokeWidth="1.4" /><path d="M2 6h10M5 3v8" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Product managers</span><span className="nm-sub">UI strings, in-app copy, release notes</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/design-ops">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.5L11.5 4v6L7 12.5 2.5 10V4z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M7 1.5v11M2.5 4L11.5 10M11.5 4L2.5 10" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Design ops</span><span className="nm-sub">Figma frames into 22 languages</span></div>
                  </Link>
                </div>
              </div>
            </div>
            <Link to="/blog" className={active === 'blog' ? 'active' : ''}>Blog</Link>
            <Link to="/contact" className={active === 'contact' ? 'active' : ''}>Contact</Link>
          </nav>
          <div className="rs-nav-cta">
            <RushThemeToggle />
            <Link className="btn btn-ghost-quiet btn-sm" to="/login">Sign in</Link>
            <Link className="btn btn-primary btn-sm" to="/register">Sign up</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export const RushFooter = () => (
  <footer className="rs-footer">
    <div className="rs-container">
      <div className="rs-footer-grid">
        <div>
          <Link to="/" className="rs-logo rs-logo-img" style={{ marginBottom: 12 }} aria-label="Rush Studio">
            <img src={rushLogo} alt="Rush Studio" />
          </Link>
          <p style={{ color: 'var(--ink-3)', fontSize: 13, maxWidth: 280, margin: 0 }}>
            One translation dashboard for the whole localization pipeline. From upload to delivery, in 100+ languages.
          </p>
        </div>
        <div>
          <h5>Product</h5>
          <ul>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/languages">Languages</Link></li>
            <li><Link to="/integrations">Integrations</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h5>Company</h5>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/customers">Customers</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h5>Resources</h5>
          <ul>
            <li><Link to="/blog">Blog</Link></li>
            <li>Docs</li>
            <li>Changelog</li>
            <li><Link to="/security">Security</Link></li>
            <li>Status</li>
          </ul>
        </div>
      </div>
      <div className="rs-footer-bottom">
        <span>© {new Date().getFullYear()} Rush Studio Ltd.</span>
        <span><Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> · <Link to="/gdpr">DPA</Link></span>
      </div>
    </div>
  </footer>
);

// Hook: scroll-reveal animations (IntersectionObserver). Returns nothing; idempotent.
export const useRushReveal = () => {
  React.useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    const id = requestAnimationFrame(() => {
      document.querySelectorAll('.reveal, .stagger').forEach((el) => io.observe(el));
    });
    return () => { cancelAnimationFrame(id); io.disconnect(); };
  }, []);
};
